<mat-chip
    [disabled]="!isMostRecentFilter && addedFilterLength > 1"
    [ngClass]="{ disabled: !isMostRecentFilter && addedFilterLength > 1 }"
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="selectionMenu">
    <mat-icon class="remove_filter_icon" matChipRemove (click)="removeFilter()"
        >cancel
    </mat-icon>
    <div class="normal_text">
        <ng-container *ngIf="selectedOption; else defaultLabel">
            <ng-container
                *ngIf="selectedOption.heading != 'Custom'; else customLabel">
                {{ selectedOption.heading }}
            </ng-container>
        </ng-container>
        <ng-template #defaultLabel>
            {{ filter.name }}
        </ng-template>
        <ng-template #customLabel>
            {{
                customValueDisplay(selectedOption.value) ||
                    selectedOption.heading
            }}
        </ng-template>
        <mat-date-range-input
            [rangePicker]="rangePicker"
            [formGroup]="customDateRange"
            class="hidden">
            <input
                matStartDate
                formControlName="begin"
                placeholder="Start date" />
            <input matEndDate formControlName="end" placeholder="End date" />
        </mat-date-range-input>

        <mat-date-range-picker #rangePicker id="rangepicker">
        </mat-date-range-picker>
    </div>
    <mat-icon class="toolbar_icon_colour"> arrow_drop_down </mat-icon>
</mat-chip>

<mat-menu #selectionMenu="matMenu" #matMenu="matMenu" class="user_menu">
    <div [ngSwitch]="filter.filterOptionType">
        <ng-container *ngSwitchCase="dataTypeEnum.HeadingOnly">
            <button
                *ngFor="let option of filter.options"
                mat-menu-item
                (click)="selectOption(option)">
                {{ option.heading }}
            </button>
        </ng-container>
    </div>
</mat-menu>
